import React, { useState } from 'react';
import { Send } from 'lucide-react';
import { services, contactInfo } from '../mock';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    mobile: '',
    service: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Prepare WhatsApp message
    const selectedService = services.find(s => s.id === parseInt(formData.service));
    const whatsappMessage = `
🌟 New Lead from Froma Web Website 🌟

👤 Name: ${formData.fullName}
📱 Mobile: ${formData.mobile}
💼 Selected Service: ${selectedService ? `${selectedService.title} - ${selectedService.price}` : 'Not selected'}
💬 Message: ${formData.message || 'No message provided'}

Please contact as soon as possible!
    `.trim();

    // Send to WhatsApp
    const whatsappURL = `https://wa.me/${contactInfo.whatsapp}?text=${encodeURIComponent(whatsappMessage)}`;
    window.open(whatsappURL, '_blank');

    // Reset form
    setTimeout(() => {
      setFormData({
        fullName: '',
        mobile: '',
        service: '',
        message: ''
      });
      setIsSubmitting(false);
    }, 1000);
  };

  return (
    <section
      id="contact"
      className="py-20 px-4"
      style={{ background: 'var(--bg-section)' }}
    >
      <div className="max-w-2xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="heading-2 mb-4">Get Your Free Consultation Now</h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            Fill out the form below and we'll send your details directly to our WhatsApp
          </p>
        </div>

        {/* Contact Form */}
        <form
          onSubmit={handleSubmit}
          className="bg-[var(--bg-card)] border border-[var(--border-light)] rounded-xl p-8 shadow-sm"
        >
          {/* Full Name */}
          <div className="mb-6">
            <label
              htmlFor="fullName"
              className="block body-medium font-medium mb-2"
              style={{ color: 'var(--text-primary)' }}
            >
              Full Name *
            </label>
            <input
              type="text"
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 border border-[var(--border-light)] rounded-full focus:outline-none focus:border-[var(--accent-primary)] transition-all duration-200"
              placeholder="Enter your full name"
            />
          </div>

          {/* Mobile Number */}
          <div className="mb-6">
            <label
              htmlFor="mobile"
              className="block body-medium font-medium mb-2"
              style={{ color: 'var(--text-primary)' }}
            >
              Mobile Number *
            </label>
            <input
              type="tel"
              id="mobile"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              required
              pattern="[0-9]{10}"
              className="w-full px-4 py-3 border border-[var(--border-light)] rounded-full focus:outline-none focus:border-[var(--accent-primary)] transition-all duration-200"
              placeholder="Enter 10-digit mobile number"
            />
          </div>

          {/* Choose Service */}
          <div className="mb-6">
            <label
              htmlFor="service"
              className="block body-medium font-medium mb-2"
              style={{ color: 'var(--text-primary)' }}
            >
              Choose a Service *
            </label>
            <select
              id="service"
              name="service"
              value={formData.service}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 border border-[var(--border-light)] rounded-full focus:outline-none focus:border-[var(--accent-primary)] transition-all duration-200 bg-white"
            >
              <option value="">Select a service</option>
              {services.map((service) => (
                <option key={service.id} value={service.id}>
                  {service.title} - {service.price}
                </option>
              ))}
            </select>
          </div>

          {/* Message */}
          <div className="mb-6">
            <label
              htmlFor="message"
              className="block body-medium font-medium mb-2"
              style={{ color: 'var(--text-primary)' }}
            >
              Message (Optional)
            </label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="4"
              className="w-full px-4 py-3 border border-[var(--border-light)] rounded-2xl focus:outline-none focus:border-[var(--accent-primary)] transition-all duration-200 resize-none"
              placeholder="Tell us about your requirements..."
            />
          </div>

          {/* Submit Button */}
          <button type="submit" disabled={isSubmitting} className="btn-primary w-full">
            {isSubmitting ? (
              'Sending...'
            ) : (
              <>
                Get Free Consultation
                <Send className="ml-2" size={20} />
              </>
            )}
          </button>

          <p className="text-center mt-4 text-sm" style={{ color: 'var(--text-muted)' }}>
            By submitting, you'll be redirected to WhatsApp with your details pre-filled
          </p>
        </form>
      </div>
    </section>
  );
};

export default ContactForm;
